import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const PlanePlay = ({playing, effect}) => { 
    const onClick = useCallback(() => {
        effect.playingParameter.set(!playing);
    }, [playing, effect]);
    let className = "plane-play";
    if (playing) {
        className += " pause-btn";
    } else {
        className += " play-btn";
    }
    return (<div onClick={onClick} className={className}/>);
}

const mapStateToProps = (state, props) => {
  return {
      playing: props.effect.playing
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanePlay);
